module.exports = __webpack_public_path__ + "static/img/MD.83abd003.svg";